export default __webpack_public_path__ + "curve1.png";